export default __webpack_public_path__ + "assets/images/0150ae22a6a4fafdf4f5ba98e1b634ba.svg";